module.exports = __webpack_public_path__ + "img/modelo3d-recopila.e5726d51.png";